import ExpandTransition from './ExpandTransition.vue'

export { ExpandTransition }
export default ExpandTransition
